export enum CheckStatus {
  OK = 1,
  WARNING = 10,
  ERROR = 20,
}
